// Single source of truth for Google Maps configuration.
// ALL map files must import from here — never define LIBRARIES locally.
//
// visualization = HeatmapLayer (CompetitorMap)
// drawing       = polygon drawing (SectionsManager, LiveMap)
// geometry      = distance calculations (all maps)

export const GOOGLE_MAPS_KEY = "AIzaSyCnYs5O0ln5DWlshgPWPy5FJhNmneDHCtk";

// Must include ALL libraries needed by ANY map in the project.
export const GOOGLE_MAPS_LIBRARIES = ["drawing", "geometry", "visualization"];
